import { AdminRouter, AdminSidebar } from '../stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'dispatch'

AdminRouter.addRoute({
  name: `${base}`,
  path: `/${base}`,
  component: () => import('./Map.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItems([
  {
    id: `${base}`,
    order: 30,
    header: ($vm) => $vm.$t(`general.menu_management`),
    text($vm) {
      return $vm.$t(`${base}.title`)
    },
    route: {
      name: `${base}`,
    },
    icon: 'icon-vcard',
    permission($vm) {
      return $vm.$allows('users.index') || $vm.$allows('users.serve')
    },
  },
])

messageGroups.push(base)
